<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CWFQ4g/tc-custom/9781460359662.jpg?1726518836926" alt="This image is the cover for the book Maggie's Beau"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maggie's Beau
      </h1>
      <p class="bookDescription body article font2">
        <p>On the run from a nightmarish life, Maggie had the power to stir feelings of forever in rancher Beau Jackson's soul. From the first moment, he knew he loved this sweet-spirited gamin, but would she ever feel anything more for him than gratitude?<br/><br/>She must have died and gone to heaven, Maggie O'Neill swore, for Beau Jackson treated her with all the kindness and respect only a genuine lady deserved. But how was she to know if what she felt for him was love?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carolyn Davidson
      </h2>
      
      <p class="authorDescription body article">Reading has always been Carolyn Davidson&rsquo;s favourite thing to do. She loves the written word, ranging from her early loves, Louisa May Alcott and Zane Grey, to present-day writers. Over the past several years, it&rsquo;s been her turn to compose books that bring pleasure to her readers. Carolyn loves to hear from her readers and no matter how busy she is Carolyn always takes time to answer her mail. You can reach her at P.O. Box 2757, Goose Creek, SC 29445</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b8a56b8a